module.exports = __webpack_public_path__ + "static/img/nodata.22e2ca2.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/mains/nodata.png
// module id = 4oWk
// module chunks = 1